import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
export const CallTrackingModal = ({ isOpen, onOpenChange }) => {
    const { t } = useI18n();
    const callTrackingText = t("contact.form.legal_text.call_tracking_modal_v2");
    return (_jsx(Modal, { title: t("contact.form.legal_text.modal_label_one"), titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: onOpenChange, children: _jsx(Box, { paddingTop: 0, typography: "typography.body.12.regular", dangerouslySetInnerHTML: { __html: callTrackingText } }) }));
};
